import { render, staticRenderFns } from "./Page403.vue?vue&type=template&id=bcefb45c"
import script from "./Page403.vue?vue&type=script&lang=ts"
export * from "./Page403.vue?vue&type=script&lang=ts"
import style0 from "./Page403.vue?vue&type=style&index=0&id=bcefb45c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports